import { useTranslation } from 'react-i18next';

import { LOCALES } from '../../../constants/locales';

const LANDING_LOCALES = [
  { code: LOCALES.EN, label: 'EN' },
  { code: LOCALES.UA, label: 'UA' },
];

/**
 * The landing page is written in English and Ukrainian only, so it gets its own
 * two-way toggle rather than the app-wide switcher (which also offers RU).
 * The choice is stored under the same `LANGUAGE` key, so it follows the visitor
 * into the app after they sign in.
 */
export const LandingLanguageToggle = () => {
  const { i18n } = useTranslation();
  const active = i18n.language === LOCALES.UA ? LOCALES.UA : LOCALES.EN;

  const select = (locale: string) => {
    localStorage.setItem('LANGUAGE', locale);
    i18n.changeLanguage(locale);
  };

  return (
    <div className="lp-lang" role="group" aria-label="Language">
      {LANDING_LOCALES.map(({ code, label }) => (
        <button
          key={code}
          type="button"
          className="lp-lang__btn"
          aria-pressed={active === code}
          onClick={() => select(code)}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default LandingLanguageToggle;
